import { Button, Card, Space, message, Modal, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/TableComponent";
import AddSubcategory from "./AddSubcategory";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

function SubcategoryTable() {
  const [showDelete, setShowDelete] = useState(false);
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const [form] = Form.useForm();
  const [searchVisible, setSearchVisible] = useState(false);

  const columns = [
    {
      title: "Sub Category",
      dataIndex: "subcategory",
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Banner Text",
      dataIndex: "banner_text",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          <Space>
            <Button size="small" onClick={() => editRecord(record)}>
              <EditOutlined />
            </Button>
            <Button
              size="small"
              onClick={() => {
                setSelectedRecord(record);
                setShowDelete(true);
              }}
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const [messageApi, contextHolder] = message.useMessage();
  const [responseData, getRequest] = useApi(
    `/config/subcategory?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [deleteResponse, deleteRequest] = useApi();
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.error && !deleteResponse.isLoading) {
      setConfirmDeletePCLoading(false);
      setSelectedRecord(null);
      setShowDelete(false);
      messageApi.open({
        type: "error",
        content: deleteResponse.error,
      });
    } else if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      setConfirmDeletePCLoading(false);
      setSelectedRecord(null);
      setShowDelete(false);
      messageApi.open({
        type: "success",
        content: "Subcategory deleted successfully",
      });
    }
  }, [deleteResponse]);

  const handleAddSubCategory = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
      setCurrentPage(1);
    }
  };

  const handleEditSubCategory = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
      setCurrentPage(1);
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(null, API_METHODS.DELETE, `/config/subcategory/${record.id}`);
  };

  const handleSearch = () => {
    const values = form.getFieldsValue();
    setCurrentPage(1);
    let url = `/config/subcategory?pageNumber=1`;

    if (values.subcategory) {
      url += `&subcategory=${encodeURIComponent(values.subcategory)}`;
    }
    if (values.category) {
      url += `&category=${encodeURIComponent(values.category)}`;
    }

    getRequest(null, API_METHODS.GET, url);
  };

  const handleReset = () => {
    form.resetFields();
    setCurrentPage(1);
    getRequest(null, API_METHODS.GET, `/config/subcategory?pageNumber=1`);
  };

  const onPaginationChange = (page) => {
    const values = form.getFieldsValue();
    let url = `/config/subcategory?pageNumber=${page.current}`;

    if (values.subcategory) {
      url += `&subcategory=${encodeURIComponent(values.subcategory)}`;
    }
    if (values.category) {
      url += `&category=${encodeURIComponent(values.category)}`;
    }

    getRequest(null, API_METHODS.GET, url);
    setCurrentPage(page.current);
  };

  return (
    <Card
      title="Subcategories"
      extra={
        <>
          <Button
            onClick={() => setSearchVisible(!searchVisible)}
            style={{ marginRight: 8 }}
          >
            {searchVisible ? "Hide Search" : "Search"}
          </Button>
          <Button type="primary" onClick={handleAddSubCategory}>
            Add Sub Category
          </Button>
        </>
      }
    >
      {contextHolder}

      {searchVisible && (
        <div
          style={{
            padding: "16px",
            background: "#f5f5f5",
            marginBottom: "16px",
            borderRadius: "6px",
          }}
        >
          <Form form={form} layout="inline">
            <Form.Item name="subcategory" label="Subcategory">
              <Input
                placeholder="Search by subcategory"
                style={{ width: 200 }}
              />
            </Form.Item>
            <Form.Item name="category" label="Category">
              <Input placeholder="Search by category" style={{ width: 200 }} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSearch}>
                Search
              </Button>
              <Button onClick={handleReset} style={{ marginLeft: 8 }}>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}

      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visible && (
        <AddSubcategory visible={visible} close={handleAddSubCategory} />
      )}

      {visibleEdit && (
        <AddSubcategory
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditSubCategory}
        />
      )}

      {showDelete && (
        <Modal
          title="Delete Subcategory"
          open={showDelete}
          onOk={() => deleteOk(selectedRecord)}
          okText="Yes"
          okButtonProps={{
            loading: confirmDeletePCLoading,
          }}
          onCancel={() => setShowDelete(false)}
        >
          Are you sure to delete <b>{selectedRecord?.subcategory}?</b>
        </Modal>
      )}
    </Card>
  );
}

export default SubcategoryTable;
